import React from "react";

const MondayIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.97585 31.9822C4.09161 31.9842 3.22272 31.7513 2.45792 31.3075C1.69312 30.8638 1.05984 30.2249 0.622763 29.4562C0.19238 28.693 -0.0222628 27.827 0.00182593 26.9512C0.0259146 26.0753 0.287828 25.2224 0.75951 24.484L9.72398 10.4067C10.1828 9.65016 10.8342 9.02893 11.6117 8.6065C12.3891 8.18406 13.2648 7.97555 14.1492 8.00228C15.033 8.02346 15.8952 8.27906 16.6478 8.74292C17.4003 9.20678 18.016 9.86224 18.432 10.6422C19.2677 12.2224 19.1633 14.1236 18.1624 15.6069L9.20358 29.6841C8.74927 30.3921 8.1236 30.9739 7.38456 31.3756C6.64551 31.7773 5.81701 31.986 4.97585 31.9822Z",
  fill: "#F62B54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.352 31.9822C18.544 31.9822 16.8802 31.0155 16.0066 29.4619C15.5771 28.7008 15.363 27.8371 15.3871 26.9635C15.4112 26.0899 15.6726 25.2393 16.1433 24.503L25.0907 10.458C25.5427 9.6908 26.1918 9.0585 26.9706 8.62669C27.7494 8.19488 28.6295 7.97929 29.5197 8.00227C31.343 8.04216 32.9954 9.06206 33.831 10.6574C34.661 12.2528 34.5395 14.1653 33.5082 15.6449L24.5627 29.6898C24.1098 30.3948 23.4866 30.9743 22.7508 31.3749C22.0149 31.7755 21.1899 31.9844 20.352 31.9822Z",
  fill: "#FFCC00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.3848 32.1C37.9337 32.1 40 30.0771 40 27.5817C40 25.0863 37.9337 23.0634 35.3848 23.0634C32.8359 23.0634 30.7697 25.0863 30.7697 27.5817C30.7697 30.0771 32.8359 32.1 35.3848 32.1Z",
  fill: "#00CA72"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MondayIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;